import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import Hero from '../../components/marketing/Hero';
import CtaBanner from '../../components/marketing/CtaBanner';
import Link from '../../components/Link';
import s from './Careers.css';

// Careers — ADDITIVE company careers page.
// HONESTY: there are NO open roles, salaries, or guaranteed benefits to advertise. Do NOT invent job
// listings or promise compensation/perks. This page shares mission + culture and invites open
// applications to careers@besthandapp.com / /contact-us.
// LEGAL_REVIEW_REQUIRED: any future statements about compensation, benefits, equal-opportunity language
// or employment terms must be reviewed by counsel before they go live.

const VALUES = [
  {
    icon: 'M12 2 4 6v6c0 5 3.4 8 8 10 4.6-2 8-5 8-10V6l-8-4ZM9 12l2 2 4-4',
    title: 'Trust first',
    text: 'We earn trust on both sides of the marketplace — for customers and for the pros who do the work.',
  },
  {
    icon: 'M13 2 3 14h7l-1 8 10-12h-7l1-8Z',
    title: 'Move with purpose',
    text: 'Small team, real ownership. We ship thoughtfully and fix what matters.',
  },
  {
    icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
    title: 'Respect the craft',
    text: 'We’re building tools for skilled local pros — and we sweat the details that make their day easier.',
  },
  {
    icon: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z',
    title: 'Stay honest',
    text: 'Clear, transparent communication — with our users, our pros, and each other.',
  },
];

const WHY = [
  { title: 'Real impact', text: 'Your work reaches customers and pros directly — there’s a short line from idea to impact.' },
  { title: 'Ownership', text: 'A small team means broad responsibility and the room to drive things end to end.' },
  { title: 'Mission that matters', text: 'Help everyday people get things done, and help local pros earn on their own terms.' },
];

function Careers() {
  return (
    <main className={s.page}>
      <Hero
        eyebrow="Careers"
        title="Help build the future of local services."
        subtitle="BestHand connects people with trusted local pros for the work that keeps homes and businesses running. We’re a small team with big ambitions — and we’d love to hear from great people."
        primaryLabel="Get in touch"
        primaryTo="/contact-us"
        secondaryLabel="About BestHand"
        secondaryTo="/about-besthand"
      />

      {/* Mission */}
      <section className={s.sec}>
        <div className={s.wrap}>
          <div className={s.mission}>
            <h2 className={s.h2}>Our mission</h2>
            <p className={s.missionText}>
              We’re making it effortless to get trusted help — and rewarding to provide it. Every booking is a
              chance to earn someone’s trust, and every pro on the platform is someone building a livelihood on
              their own schedule. That’s the work we show up for.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className={`${s.sec} ${s.alt}`}>
        <div className={s.wrap}>
          <h2 className={s.h2}>What we value</h2>
          <div className={s.grid}>
            {VALUES.map((v) => (
              <div className={s.card} key={v.title}>
                <span className={s.cardIc}>
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d={v.icon} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <h3 className={s.cardTitle}>{v.title}</h3>
                <p className={s.cardText}>{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why work here */}
      <section className={s.sec}>
        <div className={s.wrap}>
          <h2 className={s.h2}>Why work at BestHand</h2>
          <div className={s.whyGrid}>
            {WHY.map((w) => (
              <div className={s.whyCard} key={w.title}>
                <h3 className={s.whyTitle}>{w.title}</h3>
                <p className={s.whyText}>{w.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* No open roles — open application */}
      <section className={`${s.sec} ${s.alt}`}>
        <div className={s.wrap}>
          <div className={s.openCard}>
            {/* HONESTY: no roles posted — do not list fake openings. */}
            <h2 className={s.h2Left}>No open roles right now</h2>
            <p className={s.openText}>
              We don’t have any positions posted at the moment — but we’re always glad to meet talented people.
              Tell us a bit about yourself and what you’d love to work on, and we’ll reach out if there’s a fit.
            </p>
            <div className={s.openActions}>
              <Link to="/contact-us" className={s.openBtn}>Tell us about you</Link>
              <a href="mailto:careers@besthandapp.com" className={s.openBtnAlt}>careers@besthandapp.com</a>
            </div>
          </div>
        </div>
      </section>

      <CtaBanner
        title="Not looking to join — but need a hand?"
        subtitle="Book a trusted local pro in minutes."
        primaryLabel="Browse services"
        primaryTo="/services"
        secondaryLabel="Become a Pro"
        secondaryTo="/become-a-pro"
      />
    </main>
  );
}

export default withStyles(s)(Careers);
